import styled from 'styled-components'

import { AMWELL_COLORS } from '../../../lib'
const { MODAL_BG_DARK, PRIMARY_CTA_BLUE } = AMWELL_COLORS

const AmwellInvisibleContainer = styled.div`
  width: 100vw;
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow-x: hidden;
  padding: 24px;
`

const AmwellContainer = styled.div`
  overflow-y: auto;
  min-width: 452px;
  width: 60vw;
  background: ${MODAL_BG_DARK};
  color: white;
  z-index: 2000;
  border-radius: 8px;
  height: 92vh;
`

const AmwellBody = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`

const AmwellScriptHeader = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  padding: 24px;
  height: 76px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
`

const AmwellContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 16px 8px;

`

const AmwellFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
`

const AmwellScriptHeading = styled.div`
  font-size: 28px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
  flex: 1;
  display: flex;
`

const CloseModalButtonDark = styled.div`
  #mdiv {
    width: 40px;
    height: 40px;
    cursor: pointer;
    display: flex;
    align-items: center;

    &:hover {
      background-color: rgb(35, 42, 48);
      border-radius: 50%;
    }
  }
  .mdiv {
    height: 28x;
    width: 2px;
    margin-left: 19px;
    background-color: rgba(255, 255, 255, 0.75);
    transform: rotate(45deg);
    z-index: 1;
  }
  .md {
    height: 28px;
    width: 2px;
    background-color: rgba(255, 255, 255, 0.75);
    transform: rotate(90deg);
    z-index: 2;
  }
`

const AmwellScriptNameInput = styled.input`
  font-size: 24px;
  font-weight: 600;
  font-family: "Open Sans";
  font-stretch: normal;
  font-style: normal;
  padding: 16px;

  background-color: rgba(255, 255, 255, 0.05);

  cursor: cursor;
  letter-spacing: 0.6px;
  color: white;
  border: none;
  outline: none;
  margin-bottom: 16px;

  &::placeholder {
    color: rgba(255, 255, 255, 0.35);
  }
`

const AmwellPlatter = styled.div`
  width: 100%;
  font-family: "Open Sans";
  cursor: pointer;
  position: relative;
  margin-bottom: 16px;
  padding: 16px;
  background-color: rgba(255, 255, 255, 0.05);

  .label {
    height: 24px;
    margin: 0;
    font-size: 16px;
    color: rgba(255, 255, 255, 0.75);
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: 0.5px;
  }

  .section-name {
    height: 24px;
    font-size: 18px;
    color: white;
    margin: 0;
    margin-top: 4px;
    font-weight: 600;
  }
`

const AmwellSectionOptions = styled.div`
  position: absolute;
  left: 0;
  width: 400px;
  border-radius: 4px;
  box-shadow: 0 14px 19px 0 rgba(0, 0, 0, 0.12), 0 8px 9px 0 rgba(0, 0, 0, 0.08),
    0 4px 5px 0 rgba(0, 0, 0, 0.06), 0 1px 2px 0 rgba(0, 0, 0, 0.04);
  background-color: #232a30;
  padding: 16px 0px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-height: 350px;
  overflow: scroll;
  z-index: 9999;
`

const AmwellScriptOption = styled.div`
  color: #fff;
  height: 22px;
  width: 100%;
  height: 50px;
  padding: 16px;
  display: flex;
  align-items: center;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  &:hover {
    cursor: pointer;
    background-color: rgba(255, 255, 255, 0.07);
  }
`

const AmwellSectionBlock = styled.div`
  position: relative;
  width: 100%;

  .ql-editor.ql-blank::before {
    font-family: "Open Sans";
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: rgba(255, 255, 255, 0.35);
  }
`

const AmwellActionButton = styled.button`
  padding: 8px 16px;
  color: ${PRIMARY_CTA_BLUE};
  background: none;
  border: none;
  cursor: pointer;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;

  &:hover {
    background-color: rgba(153, 153, 153, 0.1);
  }
`

export {
  AmwellInvisibleContainer,
  AmwellContainer,
  AmwellBody,
  AmwellContent,
  AmwellFooter,
  AmwellScriptHeader,
  AmwellScriptHeading,
  CloseModalButtonDark,
  AmwellScriptNameInput,
  AmwellPlatter,
  AmwellSectionOptions,
  AmwellScriptOption,
  AmwellSectionBlock,
  AmwellActionButton
}
